// extracted by mini-css-extract-plugin
export default {"disclaimerContainer":"disclaimer-container__disclaimer-container__NWQEU"};